module.exports = __webpack_public_path__ + "static/media/achievement-oscar-nominee.99aacae6.svg";